<template>
<div class="form">
<a-card :title="c_title">
    <v-gobackbutton slot="extra" >返回</v-gobackbutton>
    <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item ref="organizationcode" v-show="record.organizationcode != ''" label="组织编码" prop="organizationcode">

            <span class="form_span">{{record.organizationcode}}</span>
        </a-form-model-item>
        <a-form-model-item ref="organizationname" label="组织名称" prop="organizationname">
            <a-input
                v-if="is_vue_task"
                v-model="record.organizationname"
                :disabled="disabled"
                    @blur="
                    () => {
                        $refs.organizationname.onFieldBlur();
                    }
                    "
            />
            <span v-else class="form_span">{{record.organizationname | filterA}}</span>

        </a-form-model-item>
        <a-form-model-item ref="organizationtype" label="组织类型" prop="organizationtype">

            <a-select v-if="is_vue_task" v-model="record.organizationtype" placeholder="请选择" style="width:181.25px" >
                <a-select-option value="公司">
                公司
                </a-select-option>
                <a-select-option value="部门">
                部门
                </a-select-option>
                <a-select-option value="小组">
                小组
                </a-select-option>
            </a-select>
            <span v-else class="form_span">{{record.organizationtype}}</span>

        </a-form-model-item>
<!--        <a-form-model-item ref="fullname" label="组织负责人" prop="fullname">-->

        <!--            <div class="form_span_little">{{record.fullname}}</div>-->
        <!--            <a-button type="primary" class="form_little_btn" @click="handleUserSelect">-->
        <!--                选择-->
        <!--            </a-button>-->
        <!--        </a-form-model-item>-->
        <a-form-model-item ref="uporganizationname" label="上级组织" prop="uporganizationname">


            <span  class="form_span_little">{{record.uporganizationname}}</span>

             <a-button type="primary" class="form_little_btn" @click="handleUpOrgSelect">
                选择
            </a-button>

        </a-form-model-item>
        <a-form-model-item ref="nchecked" label="有效性" prop="nchecked">
            <a-switch  v-if="is_vue_task" v-model="record.nchecked" checked-children="有效" :disabled="disabled" un-checked-children="无效" />
            <span v-else class="form_span">{{record.nchecked ? '有效' : '无效'}}</span>
        </a-form-model-item>


        <a-form-model-item :wrapper-col="{ span: 14, offset: 14 }" v-show="is_vue_task">
            <a-button type="primary" @click="handleOk">
                保存
            </a-button>
            <a-button style="margin-left: 10px;" @click="handleCancel">
                取消
            </a-button>
        </a-form-model-item>
    </a-form-model>

    <uporgselect ref="uporgselect"  @onModalHide="handleModalHide"></uporgselect>

    <userselect ref="userselect"  @onModalHide="handleModalHideUser"></userselect>
</a-card>
</div>

</template>
<script>
import uporgselect from './uporgselect'
import userselect from './userselect'
import { mapState } from "vuex";
const m_title = {
    'orgadd':'新增组织',
    'orgdetail':'查看组织',
    'orgedit':'编辑组织',
};
export default {
    data() {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            rules: {

                organizationname: [
                    { required: true, message: '请输入组织名称', trigger: 'blur' },
                ],
                organizationtype:[
                    { required: true, message: '请输入组织类型', trigger: 'blur' },
                ],
                isvalidity:[
                    { required: true, message: '有效性', trigger: 'blur'  },
                ],
            },
            readonlyed:'readonly',
            confirmLoading: false,
            formItemLayout:'horizontal',
            c_title:'',
            is_vue_task : true,
            disabled: this.$route.params.action == "orgdetail" ? true : false
        };
    },
    filters:{
        filterA:function(value){
            return value+'123'
        }
    },
    methods: {
        handleOk() {
            let that = this;
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    that.record.isvalidity = that.record.nchecked ? '1' : '0';
                    const { params } = that.$route;
                    if(params.action == 'orgedit'){
                        //编辑
                        that.$store
                            .dispatch({
                                type: "orgcenter/updateAddTask",
                                params: that.record
                            })
                            .then((response) => {
                                console.log(response)
                                that.handleCancel();
                                that.confirmLoading = false;
                            });
                    }
                    else if(params.action == 'orgadd'){
                        //新增
                        that.$store
                            .dispatch({
                                type: "orgcenter/updateAddTask",
                                params: that.record
                            })
                            .then((response) => {
                                console.log(response)
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                    that.confirmLoading = false;
                                }

                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },

        handleModalHide(result){
            if(!result){
                return
            }
            this.record.uporganizationcode = result[0].uporganizationcode;
            this.record.uporganizationname = result[0].uporganizationname;
        },
        handleModalHideUser(result){
            if(!result){
                return
            }
            this.record.fullname = result[0].fullname;
            this.record.organizationleader = result[0].organizationleader;
        },

        handleUpOrgSelect(){
            this.$refs.uporgselect.onModalInit('',1);
        },

        handleUserSelect(){
            this.$refs.userselect.onModalInit(1);
        }
    },
    computed: {
        ...mapState("orgcenter", {
            record: function(state) {
                return this.action == "orgadd" ? {} : state.record;
            }
        })
    },
    components:{
        uporgselect,
        userselect
    },
    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action]
        if (params.action != "orgadd") {
            this.$store.dispatch({
                type: "orgcenter/detailOrg",
                params: query,
                showMsg: false
            })
        }
        else{
            this.$store.dispatch({
                type: "orgcenter/getEmptyOrg",
                params: query,
                showMsg: false
            })
        }
        this.is_vue_task = params.action != 'orgdetail'

    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
.ant-input[disabled]{
    color: rgba(0, 0, 0, 0.55);
}
.form_span{
    font-size: 14px;
    font-weight: bolder;
}
.form_little_btn{
    margin-left: 20px;
}

.form_span_little{
    width:150px;
    padding-left:10px;
    border:1px solid #d9d9d9;
    border-radius: 4px;
    height: 35px;
    margin-top: 2px;
    line-height: 35px;
    float: left;
}
</style>
